import React__default, { useEffect, useState } from 'react';
import { throttle } from 'diskho';

var counter = 0;
var getNextInteger = function getNextInteger() {
  var next = counter;
  counter = counter + 1 | 0;
  return next;
};
var useClickOutside = function useClickOutside(ref, callback) {
  var onClick = function onClick(e) {
    if (ref && ref.current && !ref.current.contains(e.target) && typeof callback === "function") {
      callback(e);
    }
  };
  useEffect(function () {
    if (window) {
      window.addEventListener("click", onClick);
    }
    return function () {
      if (window && onClick) {
        window.removeEventListener("click", onClick);
      }
    };
  });
};
var useDevice = function useDevice(direction, breakpoint) {
  var _useState2 = useState(process.browser ? window.innerWidth : 1200),
    width = _useState2[0],
    setWidth = _useState2[1];
  useEffect(function () {
    if (process.browser) {
      var handleResize = throttle(function () {
        return setWidth(window.innerWidth);
      }, 1000);
      window.addEventListener("resize", handleResize);
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
  }, [width]);
  return direction === "gt" ? width > breakpoint : width < breakpoint;
};
var focusedElement = function focusedElement(element) {
  return element.querySelector(":focus");
};
var childrenToText = function childrenToText(children) {
  var childArray = React__default.Children.toArray(children);
  return childArray.filter(function (x) {
    return typeof x === "string";
  }).join(" ");
};
var useCurrentSrc = function useCurrentSrc(ref, defaultSrc) {
  var _useState3 = useState(defaultSrc),
    image = _useState3[0],
    setImage = _useState3[1];
  useEffect(function () {
    var current = ref.current;
    if (current && current.currentSrc) {
      setImage(current.currentSrc);
    }
  }, [ref]);
  return image;
};

export { childrenToText, focusedElement, getNextInteger, useClickOutside, useCurrentSrc, useDevice };
//# sourceMappingURL=utils.js.map
